import { ChangeDetectorRef, Component } from '@angular/core';
import { AXFWidgetPrint } from '../../../config/widget';

@Component({
  templateUrl: './text-input-widget.print.html',
})
export class AXFTextInputWidgetPrint extends AXFWidgetPrint {
  placeholder!: string;
  textStyle!: string[];
  textAlign!: string;
  color!: string;
  defaultValue!: string;
  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
    if (this.value === undefined && this.defaultValue !== undefined) {
      this.value = this.defaultValue;
    }
    if (
      this.value == undefined &&
      (this as any)['rIndex'] >= 0 &&
      (this as any)['dataContext'] != undefined &&
      (this as any)['dataContext'].hasOwnProperty((this as any)['name'])
    ) {
      this.value = (this as any)['dataContext'][(this as any)['name']];
    }
    this.cdr.detectChanges();
  }
}
